var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#D7E2F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9667_54934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33366H15.3333V8.00033C15.3333 6.16033 13.84 4.66699 12 4.66699C10.16 4.66699 8.66666 6.16033 8.66666 8.00033V9.33366H7.99999C7.26666 9.33366 6.66666 9.93366 6.66666 10.667V17.3337C6.66666 18.067 7.26666 18.667 7.99999 18.667H16C16.7333 18.667 17.3333 18.067 17.3333 17.3337V10.667C17.3333 9.93366 16.7333 9.33366 16 9.33366ZM12 15.3337C11.2667 15.3337 10.6667 14.7337 10.6667 14.0003C10.6667 13.267 11.2667 12.667 12 12.667C12.7333 12.667 13.3333 13.267 13.3333 14.0003C13.3333 14.7337 12.7333 15.3337 12 15.3337ZM14.0667 9.33366H9.93332V8.00033C9.93332 6.86033 10.86 5.93366 12 5.93366C13.14 5.93366 14.0667 6.86033 14.0667 8.00033V9.33366Z",
    fill: "#3E4C5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9667_54934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.0eea2c253918fa9a642bfe3bb4ab0305.svg";
export { ForwardRef as ReactComponent };